import { render, staticRenderFns } from "./logManagement.vue?vue&type=template&id=60f72242&"
import script from "./logManagement.vue?vue&type=script&lang=js&"
export * from "./logManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports